// extracted by mini-css-extract-plugin
module.exports = {"Title":"PostExcerpt-module__Title___224u5","title":"PostExcerpt-module__Title___224u5","Exerpt":"PostExcerpt-module__Exerpt___2Nyyf","exerpt":"PostExcerpt-module__Exerpt___2Nyyf"};